var map = {
	"./capa_totem.jpg": 358,
	"./totem1.jpg": 359,
	"./totem2.jpg": 360,
	"./totem3.jpg": 361,
	"./totem4.jpg": 362,
	"./totem5.jpg": 363
};
function webpackContext(req) {
	return __webpack_require__(webpackContextResolve(req));
};
function webpackContextResolve(req) {
	var id = map[req];
	if(!(id + 1)) // check for number or string
		throw new Error("Cannot find module '" + req + "'.");
	return id;
};
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = 20;


//////////////////
// WEBPACK FOOTER
// ./src/fotos/Totem nonrecursive \.(jpg|jpeg|png|gif)$
// module id = 20
// module chunks = 0